import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import { ajax } from "jquery";
import extend from "extend";

export default class WishlistController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore("WishlistStore");
        this.basketStore = ComponentRegistry.getStore("BasketStore");

        this.state = { items: this.store.items };
        this.store.listen(items => this.setState({ items }));
    }

    onSaveNote(item, note) {
        ajax({
            url: this.props.saveNoteToWishlistUrl,
            data: {
                productId: item.product.id,
                note,
            },
            success: data => this.store.update(extend(true, {}, item, { note, feedback: data })),
        });
    }

    onPurchase(item) {
        ajax({
            url: this.props.addToBasketUrl,
            data: {
                productId: item.product.id,
                quantity: item.quantity,
            },
            success: (data) => {
                this.basketStore.load(data.basket);
                this.store.update(extend(true, {}, item, { feedback: { type: data.type, message: data.message } }));
                this.onChangeQuantity(item, item.product.minimumPurchaseAmount);
            },
        });
    }

    onChangeQuantity(item, quantity) {
        ajax({
            url: item.url,
            data: {
                quantity,
            },
            method: "POST",
            success: data => this.store.update(extend(true, {}, item, data)),
        });
    }

    onRemove(item) {
        ajax({
            url: this.props.removeUrl,
            data: {
                productId: item.product.id,
            },
            success: () => { this.store.remove(item); },
        });
    }

    render() {
        const WishlistView = ComponentRegistry.get("WishlistViewsWishlistView");
        const WishlistItemView = ComponentRegistry.get("WishlistViewsItemView");

        const items = this.state.items.map((item, index) => (
          <WishlistItemView
            {...item}
            key={index}
            labels={this.props.labels}
            onSaveNote={note => this.onSaveNote(item, note)}
            onPurchase={() => this.onPurchase(item)}
            onChangeQuantity={quantity => this.onChangeQuantity(item, quantity)}
            onRemove={() => this.onRemove(item)}
          />
            ));

        return (
          <WishlistView>{items}</WishlistView>
        );
    }
}

WishlistController.propTypes = {
    saveNoteToWishlistUrl: PropTypes.string.isRequired,
    removeUrl: PropTypes.string.isRequired,
    addToBasketUrl: PropTypes.string.isRequired,
    labels: PropTypes.shape({}).isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Wishlist/Controllers/WishlistController.jsx